import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import {
    GrpcClientsContextValue,
    useGrpcClients,
} from '@/contexts/GrpcClientContext'
import { DeletedItemSelection } from '@/generated/Enumerations/DeletedItemSelection_pb'
import { TrackingKindSortBy } from '@/generated/Enumerations/TrackingKindSortBy_pb'
import { assertNotNullish } from '@/helper/assertNotNullish'
import {
    listQueryKeyPrefix,
    trackingKindsQueryKeyPrefix,
} from '@/helper/queryKeyPrefixes'

export const trackingKindsListQueryKeyPrefix = [
    trackingKindsQueryKeyPrefix,
    listQueryKeyPrefix,
] as const

export const trackingKindsQueryOptions = (
    clients: Partial<GrpcClientsContextValue> | null
) =>
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryOptions({
        queryKey: [...trackingKindsListQueryKeyPrefix],
        queryFn: async ({ signal }) => {
            assertNotNullish(clients?.trackingKind)

            const response = await clients.trackingKind.getTrackingKinds(
                {
                    sorting: [
                        { sortBy: TrackingKindSortBy.NAME, descending: false },
                    ],
                    deletedItemSelection: DeletedItemSelection.NORMAL_ONLY,
                    ids: [],
                    searching: [],
                },
                { signal }
            )

            return response
        },
    })

export const useTrackingKinds = () => {
    const clients = useGrpcClients()

    return useSuspenseQuery(trackingKindsQueryOptions(clients))
}
